import { AdditionalServicesComponent } from "./components/additionalServices/additionalServices.component";
import { ClickAndCollectComponent } from "./components/clickAndCollect/clickAndCollect.component";
import { HomeDeliveryComponent } from "./components/homeDelivery/homeDelivery.component";
import { DeliveryCostComponent } from "./components/info/components/deliveryCost.component";
import { InfoComponent } from "./components/info/info.component";
import { DeliveryItemBase } from "./deliveryItem.base";

const InfoComponentBase = Object.assign(InfoComponent, {
    DeliveryCost: DeliveryCostComponent
});

export const DeliveryItem = Object.assign(DeliveryItemBase, {
    Info: InfoComponentBase,
    HomeDelivery: HomeDeliveryComponent,
    ClickAndCollect: ClickAndCollectComponent,
    AdditionalServices: AdditionalServicesComponent
});
